import React from 'react';
import { convertNodeToElement } from 'react-html-parser';

import Link from '../components/link/link';

const linkParser = (node: any) => {
  if (node.type === 'tag' && node.name === 'p') {
    if (
      node.children.some(
        (child: any) => child.type === 'tag' && child.name === 'a'
      )
    ) {
      node.children.forEach((child: any, index: number) => {
        if (child.type === 'tag' && child.name === 'a') {
          if (child.attribs.href?.includes('/documents/editNewOrRegister/')) {
            child.attribs.rel = 'nofollow';
          }
          convertNodeToElement(node, index, linkParser);
        }
      });
    }
  } else if (node.type === 'tag' && node.name === 'a' && node.parent) {
    if (
      node.children.some(
        (child: any) => child.type === 'tag' && child.name === 'img'
      )
    ) {
      return undefined;
    }
    if (node.attribs && node.attribs.href && node.children.length) {
      const text = node.children[0].data;
      const { style, href, ...rest } = node.attribs;

      return (
        <Link
          {...rest}
          secondary
          underline="hover"
          to={href}
          excludeFromGatsby={node.attribs.excludefromgatsby}
        >
          {text}
        </Link>
      );
    }
  }
  return undefined;
};

export default linkParser;
